<!-- 地图 -->
<style lang="less" scoped>
.bottom {
  width: 78900/1920vw;
  height: 17900/1080vh;
  margin: 4800/1080vh auto;
  margin-left: 1000/1920vw;
  // position: relative;
  // left: 0;
  // right: 0;
  background: url("../../../../../../assets/img/yinxiao/bottom.png");
  background-size: 100% 100%;
  ul {
    width: 73000/1920vw;
    height: 17900/1080vh;
    margin-left: 2650/1920vw;
    // margin-top: 2650/1920vw;
    li {
      width: 20%;
      float: left;
      height: 14400/1080vh;
      // border: 1px solid red;
      p:nth-child(1) {
        img {
          width: 4000/1080vh;
          height: 4000/1080vh;
          margin: 4000/1080vh 2200/1080vh 0px;
        }
      }
      p:nth-child(2) {
        height: 2000/1080vh;
        font-size: 2400/1080vh;
        color: rgba(213, 255, 255, 1);
        margin: 1000/1080vh 2500/1080vh 0px;
      }
      p:nth-child(3) {
        height: 1600/1080vh;
        font-size: 1600/1080vh;
        color: rgba(56, 122, 213, 1);
        margin: 1200/1080vh 2500/1080vh 1000/1080vh;
      }
    }
  }
}
</style>

<template>
  <div class="bottom">
    <ul>
      <li v-for="(item, index) in list">
        <p><img :src="item.img" /></p>
        <p>{{ item.number }}</p>
        <p>{{ item.name }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import img1 from "@/assets/img/yinxiao/icon1.png";
import img2 from "@/assets/img/yinxiao/icon2.png";
import img3 from "@/assets/img/yinxiao/icon3.png";
import img4 from "@/assets/img/yinxiao/icon4.png";
import img5 from "@/assets/img/yinxiao/icon5.png";
import countTo from "vue-count-to";
export default {
  data() {
    return {
      list: [
        {
          img: img1,
          number: 359,
          name: "月流失会员"
        },
        {
          img: img2,
          number: 10231,
          name: "月新增会员"
        },
        {
          img: img3,
          number: 450,
          name: "月流失数预估"
        },
        {
          img: img4,
          number: 8910,
          name: "月新增预估"
        },
        {
          img: img5,
          number: 582424,
          name: "月销量预估"
        }
      ]
    };
  },
  components: {},
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// index.vue?ea1a0e32